<template>
  <div>
    <form-wizard
      ref="formWizard"
      :title="null"
      :subtitle="null"
      class="bg-white mb-1"
      step-size="xs"
      shape="circle"
      @on-complete="formSubmitted"
      @on-loading="setLoading"
    >
      <template #next>
        <b-button
          variant="primary"
        >
          Proximo
        </b-button>
      </template>

      <template #prev>
        <b-button
          variant="primary"
        >
          Voltar
        </b-button>
      </template>

      <template #finish>
        <b-button
          variant="primary"
        >
          Salvar Integração
        </b-button>
      </template>
      <!-- Escolher o chat fluxo que vai ser monitorado -->
      <tab-content
        title="Para leads gerados nos fluxos"
        :before-change="validateAsync"
      >
        <b-row v-if="!loadingWizard">
          <b-col
            cols="12"
            class="mb-2"
          >
            <b-form-group>
              <v-select
                v-model="formIntegration.chatSelected"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="name"
                :reduce="chat => chat"
                :options="chatsExistents"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>

      <!-- Configuração dos campos a ser mapeado do chat (@cpf pessoa) -->
      <tab-content
        title="Configurações"
        :before-change="validateAsync"
      >
        <b-col
          cols="12"
          class="mb-2 px-0"
        >
          <h5 class="mb-0">
            RDStation
          </h5>
          <small class="text-muted">Configure sua integração do RDStation</small>
        </b-col>
        <b-row v-if="!loadingWizard">
          <b-col
            v-for="(form, index) in formIntegration.formRdStationConfig"
            :key="index"
            cols="12"
            class="mb-2"
          >
            <b-form-group>
              <div>
                <strong
                  v-if="form.id !== 'email'"
                  class="mb-5"
                >{{ form.title }}</strong>
                <strong
                  v-else
                  class="mb-5"
                >{{ form.title }} <span style="color: red">*</span></strong>
              </div>

              <Info
                :id="`form_rd_${form.id}`"
                :variaveis="variaveis"
                :is-tag-value="false"
                @atualizarMessage="atualizarValue($event, form)"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>
      <div
        v-if="loadingWizard"
        class="loader"
      />
    </form-wizard>

  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import Info from '@/views/App/Chat/Info.vue'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'
import { useApi } from '@/composables/useApi'

const apiBack = useApi()
export default {
  components: {
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    Info,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      chatsExistents: [],
      formIntegration: {
        chatSelected: '',
        formRdStationConfig: [
          { title: 'Nome do contato', id: 'name', value: '' },
          { title: 'Email do contato', id: 'email', value: '' },
          { title: 'Cargo do contato', id: 'job_title', value: '' },
          { title: 'Anotações sobre contato', id: 'bio', value: '' },
          { title: 'Site do contato', id: 'website', value: '' },
          { title: 'Telefone do contato', id: 'personal_phone', value: '' },
          { title: 'Telefone do contato', id: 'mobile_phone', value: '' },
          { title: 'Cidade do contato', id: 'city', value: '' },
          { title: 'Estado do contato', id: 'state', value: '' },
          { title: 'País do contato', id: 'country', value: '' },
          { title: 'Twitter do contato', id: 'twitter', value: '' },
          { title: 'Facebook do contato', id: 'facebook', value: '' },
          { title: 'LinkedIn do contato', id: 'linkedin', value: '' },
          { title: 'Tags do contato', id: 'tags', value: '' },
          { title: 'Bases legais do contato', id: 'legal_bases', value: '' },
        ],
      },
      variaveis: [],
      isValid: true,
      loadingWizard: false,

    }
  },
  computed: {
    getUserData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
    isFormValid: {
      get() {
        return this.formIntegration.formRdStationConfig.find(item => item.id === 'email').value === ''
      },
      set(value) {
        this.formIntegration.formRdStationConfig.find(item => item.id === 'email').value = value
      },
    },
  },
  async mounted() {
    this.setLoading(true)
    await this.getAllChats()
    this.setLoading(false)
  },
  methods: {
    atualizarValue(value, form) {
      this.formIntegration.formRdStationConfig.map(f => {
        if (f.id === form.id) {
          f.value = value.replace(/<[^>]*>/g, '')
        }
        return f
      })
    },
    resetFormIntegration() {
      this.formIntegration = {
        chatSelected: {},
        formRdStationConfig: [
          { title: 'Identificador de conversão', id: 'name', value: '' },
          { title: 'Nome da Empresa', id: 'name_company', value: '' },
          { title: 'Site da Empresa', id: 'site_company', value: '' },
          { title: 'Endereço da Empresa', id: 'address_company', value: '' },
          { title: 'Telefone', id: 'phone_company', value: '' },
          { title: 'País', id: 'country', value: '' },
          { title: 'Biografia', id: 'bio', value: '' },
          { title: 'Facebook', id: 'facebook', value: '' },
          { title: 'Cargo', id: 'job', value: '' },
          { title: 'Website', id: 'website', value: '' },
          { title: 'Linkedin', id: 'linkedin', value: '' },
          { title: 'Estado', id: 'state', value: '' },
          { title: 'Email', id: 'email', value: '' },
          { title: 'Celular', id: 'cellphone', value: '' },
          { title: 'Nome', id: 'name', value: '' },
          { title: 'Tags', id: 'tags', value: '' },
          { title: 'Twitter', id: 'twitter', value: '' },
          { title: 'Cidade', id: 'city', value: '' },
        ],
      }
    },
    validateAsync() {
      return new Promise((resolve, reject) => {
        if (this.$refs.formWizard.activeTabIndex === 0 && this.formIntegration.chatSelected === '') {
          this.$refs.formWizard.activeTabIndex = 0
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Chat não pode ser vazio',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          document.querySelector('.tinymce-heading-fluxo_form_rd_chat').focus()
          // eslint-disable-next-line prefer-promise-reject-errors
          reject(false)
          return false
        }
        if (this.$refs.formWizard.activeTabIndex === 1 && this.formIntegration.formRdStationConfig.find(item => item.id === 'email').value === '') {
          this.$refs.formWizard.activeTabIndex = 1
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'E-mail não pode ser vazio',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          document.querySelector('.tinymce-heading-fluxo_form_rd_email').focus()
          // eslint-disable-next-line prefer-promise-reject-errors
          reject(false)
          return false
        }
        this.setLoading(true)
        this.getAllVariaveis().then(() => {
          this.setLoading(false)
          resolve(true)
        })
        resolve(true)
        return true
      })
    },
    setLoading(value) {
      this.loadingWizard = value
    },
    changeTab() {
      console.log('changeTab')
    },
    async getAllChats() {
      await apiBack.get(`/chat/${this.getUserData.id}`)
        .then(data => {
          this.chatsExistents = data.data
        })
        .catch(err => console.error(err))
    },
    formSubmitted() {
      document.querySelectorAll('.gatilho-selected').forEach(item => {
        item.classList.remove('gatilho-selected')
      })
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Integração criada com sucesso!',
          icon: 'EditIcon',
          variant: 'success',
        },

      })
      const formData = {
        modelo: 'RD Station',
        fluxos: this.formIntegration.chatSelected.name,
        eventos: 'lead:finish',
        id_user: this.getUserData.id,
        id_chat: this.formIntegration.chatSelected.id,
        modelo_metadata: JSON.stringify(this.formIntegration.formRdStationConfig),
      }
      this.$store.dispatch('AppChatbooster/SAVE_INTEGRATION_DB', formData)
      this.$refs.formWizard.reset()
      this.resetFormIntegration()
    },
    async getAllVariaveis() {
      await this.$store.dispatch('AppChatbooster/GET_ACCESS_TOKEN_RDSTATION')
      await apiBack.post('/getAllVariaveisByArray', {
        array: [this.formIntegration.chatSelected.id],
      })
        .then(data => {
          this.variaveis = JSON.parse(JSON.stringify(data.data))
        })
        .catch(err => console.error(err))
    },
  },
}
</script>

<style scoped lang="scss">
.gatilho-selected {
  border: 2px solid red;
  background: #ff000017;
}

/* This is a css loader. It's not related to vue-form-wizard */
.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}

.loader {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(255, 255, 255, 0.2);
  border-right: 1.1em solid rgba(255, 255, 255, 0.2);
  border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
  border-left: 1.1em solid #e74c3c;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}

@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

</style>
